













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { User } from 'frontend/types';
import { buildPremiumRedirect } from 'frontend/utils/premium-redirect';
import { shouldOverrideHeaderButton } from 'frontend/utils/referral';

@Component({
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('response', ['requestPath']),
  },
})
export default class PremiumButton extends Vue {
  @Prop(String) private readonly axId?: string;
  @Prop(Number) private readonly targetObjectId?: number;
  @Prop(String) private readonly targetObjectType?: string;
  @Prop(String) private readonly targetObjectReferrer?: string;
  @Prop(Number) private readonly ignoreBlockedContent?: number;
  @Prop(String) private readonly returnToChapter?: string;
  @Prop(Boolean) private readonly allowLoggedOut?: boolean;
  @Prop(Object) private readonly extraQueryParams?: { [key: string]: string };

  private user!: User;
  private requestPath!: string;

  private get link() {
    return buildPremiumRedirect({
      user: this.user,
      requestPath: this.requestPath,
      axId: this.axId,
      targetObjectId: this.targetObjectId,
      targetObjectType: this.targetObjectType,
      targetObjectReferrer: this.targetObjectReferrer,
      ignoreBlockedContent: this.ignoreBlockedContent,
      returnToChapter: this.returnToChapter,
      allowLoggedOut: this.allowLoggedOut,
      extraQueryParams: this.extraQueryParams,
      inTieredPlanExperiment: null,
    });
  }

  private get shouldOverrideHeaderButtonForReferralOrGift() {
    return shouldOverrideHeaderButton(this.user);
  }
}
